if (!Array.prototype.append) {
  Object.defineProperty(Array.prototype, "append", {
    value: function (e: any) {
      this.push(e);    
      return this;
    }
  });
}

export {}